/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import classNames from 'classnames/bind';
import styles from '../../styles.module.scss';

const cx = classNames.bind(styles);

const SportPlayStyles = ({ stylesOfPlay }) => (
  <div
    className={cx('card', stylesOfPlay.length === 0 && 'px-0')}
    style={{ height: '464px', maxHeight: '464px' }}
  >
    <h2 className="text-center w-100 mb-3">Styles of Play</h2>
    {stylesOfPlay.length > 0 ? (
      <Carousel
        infiniteLoop
        autoPlay
        interval={3000}
        stopOnHover
        showThumbs={false}
        dynamicHeight
        className={cx('sportCarousel')}
      >
        {stylesOfPlay.map(({ title, description }) => (
          <div className="mx-3" key={`${title}${description}`}>
            <h4 style={{ fontSize: '20px' }} className="mb-2">
              {title}
            </h4>
            <p
              className="text-center"
              dangerouslySetInnerHTML={{ __html: description || 'Coming soon...' }}
            />
          </div>
        ))}
      </Carousel>
    ) : (
      <div className={cx('formats', 'text-center')}>
        <h3>Check back for updates!</h3>
      </div>
    )}
  </div>
);

SportPlayStyles.propTypes = {
  stylesOfPlay: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ).isRequired,
};

export default SportPlayStyles;
